export default "__VITE_ASSET__DwsrTeY6__"